import {animate, style, transition, trigger} from '@angular/animations';
import {AfterViewChecked, ChangeDetectorRef, Component} from '@angular/core';
import {FallbackLangChangeEvent, TranslateService} from '@ngx-translate/core';
import {MetaService} from '@portal-commons/meta.service';
import {PortalAuthService} from '@portal-commons/portal-auth.service';
import {LoadingService} from '@portal-commons/providers/loading.service';
import {delay, Observable} from 'rxjs';

@Component({
  selector: 'tfsport-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [style({opacity: 0}), animate(200)]),
      transition(':leave', [animate(200), style({opacity: 0})]),
    ]),
  ],
  standalone: false,
})
export class AppComponent implements AfterViewChecked {
  public loading$: Observable<boolean>;

  authenticationChecked$: Observable<boolean>;

  constructor(
    private translate: TranslateService,
    private loadingService: LoadingService,
    private changeDetector: ChangeDetectorRef,
    private metaService: MetaService,
    private auth: PortalAuthService,
  ) {
    this.metaService.updateTitle();
    // this language will be used as a fallback when a translation isn't found in the current language
    this.translate.setFallbackLang('de');

    this.translate.onFallbackLangChange.subscribe((ev: FallbackLangChangeEvent) => {
      document.querySelector('html')?.setAttribute('lang', ev.lang);
    });

    this.loading$ = this.loadingService.loading;
    this.authenticationChecked$ = this.auth.isAuthenticationChecked().pipe(delay(1000));
  }

  ngAfterViewChecked(): void {
    this.changeDetector.detectChanges();
  }
}
